import * as CryptoJS from 'crypto-js';
import { RememberMe, TokenAuth } from 'src/dto/users/users-dto';

export const environment = {
  production: false,
  productionUrl: 'https://api.staging.demo.figurino.cloud/api/',
  staticUrlImageEmpty: 'assets/images/Buccellati_empty_img.png',
  urlServer: 'https://www.figurino-buccellati-test.com/',

  languages: ['AR', 'CNS', 'CNT', 'DE', 'EN', 'ES', 'FR', 'IT', 'JP', 'KR'],
  languagesLowers: [
    'ar',
    'cns',
    'cnt',
    'de',
    'en',
    'es',
    'fr',
    'it',
    'jp',
    'kr',
  ],
  categoriesAvailable: [
    'HIGH_JEWELRY-31',
    'SILVER-36',
    'WATCHES-46',
    'BRIDAL-96',
    'JEWELRY-28',
    'GENERIC',
    'GIFTS-51',
  ],
  skuDetaillabel: ['SKUcode', 'ean', 'sizes'],
  fieldToEscludeDetails: ['sizes', 'ean', 'SKU_code'],
  fieldsInModelsCatalog: [
    'online_visibility',
    'line_desc_fe',
    'category_desc_fe',
    'subcategory_desc_fe',
    'collection_desc_fe',
  ],
  listRoleSharedWith: ['can view', 'can edit'],
  regexVersions:
    /^[A-Z0-9]+_(V0|V1|V2|V3|V4|V5|V6|EDIMG|EDVID|TECHNICAL|COVIMG|QRCODE|DRAWING|CASECLOSE|CASEOPEN|STONECERT).(png|jpg|mp4)$/,
  listChannelsCollectionBook: [
    'Collection Book',
    'Website',
    'Ecommerce China',
    'Digital Catalogue',
  ],
  listChannelsCollectionBookCode: [
    'collection_book',
    'website',
    'digital_catalogue',
  ],
  listSaleCompany: ['B100', 'B600', 'B601', 'B900', 'B920', 'B930'],

  listAttributesPricingSAP: ['pltyp', 'kbetr', 'konwa'],
  listColumnToAggregateSkuCollectionBook: ['zmatnr'],
  listColumnToAggregateStoreCollectionBook: ['zplant'],
  listRangeAttributes: ['price_from', 'price_to'],

  allowedPimRoles: ['PIM'],
  allowedDamRoles: ['DAM', 'MEDIA_MANAGER', 'GLRY_VIEW'],
  allowedDictionaryRoles: ['SUPER_ADMIN', 'ADMIN'],
  allowedCatalogsRoles: ['CATALOG'],
  allowedMediaLibraryRoles: ['GLRY_VIEW'],
  allowedManageTagsRoles: ['MEDIA_MANAGER'],
  allowedUsersRoles: ['SUPER_ADMIN'],
  allowedAdminOrSuperRoles: ['SUPER_ADMIN', 'ADMIN'],
  allowedSuperAdminRoles: ['SUPER_ADMIN'],
  currencyAvailable: [
    { name: 'EUR', value: '€' },
    { name: 'USD', value: '$' },
    { name: 'GBP', value: '' },
    { name: 'CHF', value: '' },
  ],
  pdpFieldsCollectionBook: [
    'collection_line_subline',
    'website_name_fe',
    'website_short_desc_fe',
    'collection_desc_fe',
    'line_desc_fe',
    'category_desc_fe',
    'subcategory_desc_fe',
    'subcategory_detail_fe',
    'product_availability_fe',
    'season',
    'model_code',
    'bridal_carat_fe',
    'color_clarity_fe',
    'bridal_cut_fe',
    'watch_movement_fe',
    'metal_type_2_fe',
    'website_stone_composition_fe',
    'additional_desc_collection_book_en',
    'website_editorial_long_desc_fe',
  ],

  imageExtensions: [
    'jpg',
    'jpeg',
    'png',
    'gif',
    'bmp',
    'tiff',
    'tif',
    'webp',
    'svg',
    'heif',
    'heic',
    'ico',
    'raw',
    'dng',
    'pbm',
    'pgm',
    'pnm',
    'ppm',
    'xbm',
    'xpm',
    'tga',
    'j2k',
    'jpf',
    'exr',
    'fits',
    'cdr',
    'psd',
    'ai',
    'indd',
  ],

  videoExtensions: [
    'mp4',
    'avi',
    'mov',
    'mkv',
    'flv',
    'wmv',
    'webm',
    'mpeg',
    'mpg',
    '3gp',
    'dv',
    'rm',
    'rmvb',
  ],

  invalidChars: ['-', '+', 'e', 'E', '*', '/'],

  widthSmall: '500',
  widthMedium: '500',
  widthLarge: '1500',
  excludedModules: [],
  dataSchema: 'GENERIC',
  priceListDefault: '{"pltyp": "L1"}',

  attributeLongDescription: 'websiteeditoriallongdescfe',

  secretKey:
    '094d074836293ba2fa643c7bda24150f60d44d55ebab0318a6529dce5fcacf61563f2e42127d7002b49c56133d15afca6248c942384ee38a17b7f3a25eed91dc',
};

export const PRICE_LIST_LABELS: {
  [code: string]: { name: string; currency: string };
} = {
  LG: { name: 'China RRP incl. VAT', currency: 'CNY' },
  L6: {
    name: 'Extra EU Suggested RRP excl. VAT for Jewellery and Silverware',
    currency: 'EUR',
  },
  LP: { name: 'Extra EU Suggested RRP excl. VAT for Watches', currency: 'CHF' },
  L2: { name: 'France RRP incl. VAT', currency: 'EUR' },
  LH: { name: 'Hong Kong RRP incl. VAT', currency: 'HKD' },
  L1: { name: 'Italy RRP incl. VAT', currency: 'EUR' },
  LJ: { name: 'Japan RRP incl. VAT', currency: 'JPY' },
  LK: { name: 'Korea RRP incl. VAT', currency: 'KRW' },
  LO: { name: 'Macau RRP excl. VAT', currency: 'MOP' },
  M2: { name: 'Saudi Arabia RRP incl. VAT', currency: 'SAR' },
  M1: { name: 'Singapore RRP incl. VAT', currency: 'SGD' },
  L4: { name: 'Switzerland RRP incl. VAT', currency: 'CHF' },
  LW: { name: 'Taiwan RRP incl. VAT', currency: 'TWD' },
  LL: { name: 'UAE RRP incl. VAT', currency: 'AED' },
  L3: { name: 'UK RRP incl. VAT', currency: 'GBP' },
  L5: { name: 'US RRP excl. VAT', currency: 'USD' },
  LZ: {
    name: 'Wholesale Suggested Price excl. VAT for Display and Packaging',
    currency: 'EUR',
  },
};

export const mappingCompaniesBoutique: Record<string, string[]> = {
  B980: ['S050'],
  B900: ['S034', 'S022', 'D900'],
  B910: ['S019', 'S023', 'D910'],
  B960: ['S042'],
  B700: ['S003', 'S012'],
  B200: ['S009', 'S001', 'S026', 'S013'],
  B940: ['S035', 'S036', 'S037', 'S039', 'S043', 'S044'],
  B950: ['S040', 'S041', 'S059'],
  B970: ['S045'],
  B990: ['S064'],
  B800: ['S006', 'S008', 'S014'],
  B600: ['S005', 'S010', 'S004', 'S007', 'S046', 'S011', 'S047', 'D600'],
  B601: ['D601'],
  B920: ['D920'],
  B930: [
    'S017',
    'S028',
    'S052',
    'S032',
    'S049',
    'S051',
    'S053',
    'S031',
    'S029',
    'S048',
    'S054',
    'S056',
  ],
  B100: ['P100', 'P101', 'P102'],
  B500: ['P500'],
};

export function downloadFile(fullImageUrl: string): void {
  const downloadLink = document.createElement('a');
  downloadLink.href = fullImageUrl;
  downloadLink.download = 'downloadedImage';
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
}

export function encryptObject(obj: TokenAuth): string {
  const jsonString = JSON.stringify(obj);
  const encrypted = CryptoJS.AES.encrypt(
    jsonString,
    environment.secretKey
  ).toString();
  return encrypted;
}

export function encryptRememberObject(obj: RememberMe): string {
  const jsonString = JSON.stringify(obj);
  const encrypted = CryptoJS.AES.encrypt(
    jsonString,
    environment.secretKey
  ).toString();
  return encrypted;
}

export function decryptToObject(encryptedString: string): any {
  if (!encryptedString || encryptedString.trim() === '') {
    return null;
  }

  const bytes = CryptoJS.AES.decrypt(encryptedString, environment.secretKey);
  const decryptedString = bytes.toString(CryptoJS.enc.Utf8);
  return decryptedString;
}

export function clearLocalStorage() {
  localStorage.removeItem('pageNumber');
  localStorage.removeItem('pageNumberC');
  localStorage.removeItem('ProductCatalogDetails');
  localStorage.removeItem('mediaModePref');
  localStorage.removeItem('scrollValueCatalog');
  localStorage.removeItem('CurrentUser');
  localStorage.removeItem('StoreCheckPref');
}
